<template>
  <div>
    <h2>Pick a preset</h2>

    <div class="btn-wrap" v-for="(template, index) in templates" :key="template.title+index">
      <button v-on:click="doWhateverTheRandomizeFunctionIs(template)" class="template-btn">
        {{template.title}}
      </button>

      <button class="remove-temp-btn" v-if="template.editable" @click="removeTemp(template.id)" title="remove">&times;</button>
    </div>

    <div v-if="templates.length < 1">
      You don't have any presets.
      <button v-on:click="$emit('cancel')" class="cancel">Go back</button>
    </div>

    <div v-else>
      <button v-on:click="$emit('cancel')" class="cancel">Nevermind. Cancel.</button>
    </div>

  </div>
</template>

<script>
export default {
  name: "Templates",
  data: function () {
    return {
      templates: []
    };
  },
  methods: {
    doWhateverTheRandomizeFunctionIs: function (choices) {
      this.$emit("setsticks", choices);
    },
    addLocal() {
      let existingTemps = JSON.parse(localStorage.getItem("localTemplates"));
      if (existingTemps == null) return;
      this.templates.push(...existingTemps);
    },
    removeTemp(id) {
      let tempArr = JSON.parse(localStorage.getItem("localTemplates"));
      let clean = tempArr.filter((temp) => temp.id !== id);
      localStorage.setItem("localTemplates", JSON.stringify(clean));

      let index = this.templates.findIndex(t => t.id === id);
      this.templates.splice(index, 1);
    },
  },
  mounted() {
    this.addLocal();
  },
};
</script>

<style lang="scss">
.btn-wrap {
  display: flex;
  max-width: 260px;
  margin: 10px auto;
  justify-content: space-between;
  align-items: flex-start;

  .template-btn {
    flex: 1 1 auto;
    margin: 0;
  }

  .remove-temp-btn {
    flex: 0 0 30px;
    margin: 0;
    margin-left: 10px;
    color: #c00;
    border-color: #800;
    background: #fdb;
  }
}
</style>